import { OreNavBarItem } from '@edenredespana/oreneta'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { useUI } from '@/Shared/ui/navigation'
import {
  ProtectedNavigationModal,
  ProtectedNavigationModalActions,
} from '@/Shared/ui/navigation/atoms/ProtectedNavigationModal'

interface SidebarLinkProps {
  title: string
  icon?: JSX.Element
  hover: boolean
  link?: string
}

const SidebarLink = (props: SidebarLinkProps): JSX.Element => {
  const { sidebarCollapsed, protectedNavigationModal } = useUI()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const ref = useRef<ProtectedNavigationModalActions>(null)

  const isActive = (): boolean => location.pathname === props.link

  const handleClick = (): void => {
    if (protectedNavigationModal !== null) {
      ref.current?.open(
        props.link || '/',
        protectedNavigationModal.title,
        protectedNavigationModal.description,
      )
    } else if (props.link) {
      navigate(props.link)
    }
  }

  return (
    <>
      {props.icon ? (
        <OreNavBarItem
          active={isActive()}
          title={t(props.title)}
          icon={props.icon}
          collapse={sidebarCollapsed}
          hover={props.hover}
          handleClick={handleClick}
        />
      ) : (
        <OreNavBarItem
          active={isActive()}
          title={t(props.title)}
          collapse={sidebarCollapsed}
          hover={props.hover}
          handleClick={handleClick}
        />
      )}
      <ProtectedNavigationModal ref={ref} />
    </>
  )
}

export { SidebarLink }
